export default "__VITE_ASSET__fbda1aac__"